import React from "react";
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  Switch,
  Text,
  Textarea,
  VStack,
} from "@chakra-ui/react";
import { RISK_REVIEW_INPUT_TYPES } from "../../constants/riskReviewInputTypes";

const RiskReviewFieldEditor = ({ field, onChange, onAddOption, onOptionChange, onDelete, isReadOnly }) => (
  <VStack align="stretch" spacing={3}>
    <Text fontWeight="semibold">Field</Text>
    <FormControl>
      <FormLabel>Label</FormLabel>
      <Input value={field?.label || ""} isReadOnly={isReadOnly} onChange={(event) => onChange?.("label", event.target.value)} />
    </FormControl>
    <FormControl>
      <FormLabel>Code</FormLabel>
      <Input value={field?.code || ""} isReadOnly={isReadOnly} onChange={(event) => onChange?.("code", event.target.value)} />
    </FormControl>
    <FormControl>
      <FormLabel>Input Type</FormLabel>
      <Select value={field?.inputType || "TEXT"} isDisabled={isReadOnly} onChange={(event) => onChange?.("inputType", event.target.value)}>
        {RISK_REVIEW_INPUT_TYPES.map((inputType) => (
          <option key={inputType} value={inputType}>
            {inputType}
          </option>
        ))}
      </Select>
    </FormControl>
    <Switch isChecked={Boolean(field?.required)} isDisabled={isReadOnly} onChange={(event) => onChange?.("required", event.target.checked)}>
      Required
    </Switch>
    <Switch isChecked={Boolean(field?.readOnly)} isDisabled={isReadOnly} onChange={(event) => onChange?.("readOnly", event.target.checked)}>
      Read Only
    </Switch>
    <FormControl>
      <FormLabel>Help Text</FormLabel>
      <Textarea value={field?.helpText || ""} isReadOnly={isReadOnly} onChange={(event) => onChange?.("helpText", event.target.value)} />
    </FormControl>
    <FormControl>
      <FormLabel>Width</FormLabel>
      <NumberInput value={field?.uiConfig?.width || 6} min={1} max={12} isDisabled={isReadOnly} onChange={(_, value) => onChange?.("uiConfig.width", Number.isNaN(value) ? 6 : value)}>
        <NumberInputField />
      </NumberInput>
    </FormControl>
    {["SELECT", "MULTI_SELECT", "RADIO", "QUESTION_SELECT"].includes(field?.inputType) ? (
      <VStack align="stretch" spacing={2}>
        <HStack justify="space-between">
          <Text fontWeight="medium">Options</Text>
          <Button size="xs" isDisabled={isReadOnly} onClick={onAddOption}>
            Add option
          </Button>
        </HStack>
        {(field.options || []).map((option, index) => (
          <HStack key={index}>
            <Input
              size="sm"
              value={option.label || ""}
              placeholder="Label"
              isReadOnly={isReadOnly}
              onChange={(event) => onOptionChange?.(index, "label", event.target.value)}
            />
            <Input
              size="sm"
              value={option.value || ""}
              placeholder="Value"
              isReadOnly={isReadOnly}
              onChange={(event) => onOptionChange?.(index, "value", event.target.value)}
            />
          </HStack>
        ))}
      </VStack>
    ) : null}
    <Button colorScheme="red" variant="outline" isDisabled={isReadOnly} onClick={onDelete}>
      Delete Field
    </Button>
  </VStack>
);

export default RiskReviewFieldEditor;
